import React from "react"
import PropTypes from "prop-types"
// Styles
import { HiddenCheckBox, Icon, StyledCheckbox, Wrapper } from "./Checkbox.styles"

const Checkbox = ({ checked, onChange }) => {

    return (
        <Wrapper>
            <HiddenCheckBox checked={checked} onChange={onChange} />
            <StyledCheckbox checked={checked} bgColor={checked ? "secondary" : "medGrey"}>
                <Icon viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12" />
                </Icon>
            </StyledCheckbox>
        </Wrapper>
    )
}

Checkbox.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func
}

export default Checkbox
